<template>
    <div class="viewACORD" v-if="dados">
        <div class="modal-conteudo m-2">
            <div id="divImprimir">
                <div class="row mb-2">
                    <div class="col-md-4">
                        <h6 >Número do Acórdão:</h6>
                        <span > {{dados.nrAcordao}}/{{dados.nrAnoAcordao}} - {{dados.nmColegiado}}</span>
                    </div>
                    <div class="col-md-4">
                        <h6 >Relator:</h6>
                        <span  v-html="dados.nmRelator"></span>
                    </div>
                    <div class="col-md-4">
                        <h6 >Processo:</h6>
                        <span  v-html="dados.nmProcesso"></span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-4">
                        <h6 >Tipo de processo:</h6>
                        <span  v-html="dados.nmTipoProcesso"></span>
                    </div>
                    <div class="col-md-4">
                        <h6 >Data da sessão:</h6>
                        <template v-if="dados.dtSessao == null || dados.dtSessao == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dtSessao"></span>
                        </template>
                    </div>
                    <div class="col-md-4">
                        <h6 >Número da ata:</h6>
                        <span  v-html="dados.nrAta"></span>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Interessado / Responsável / Recorrente:</h6>
                        <template v-if="dados.dsInteressados == null || dados.dsInteressados == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dsInteressados"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Entidade:</h6>
                        <template v-if="dados.nmEntidade == null || dados.nmEntidade == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.nmEntidade"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Representante do Ministério Público:</h6>
                        <template v-if="dados.nmRepresentanteEmpresa == null || dados.nmRepresentanteEmpresa == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.nmRepresentanteEmpresa"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Unidade Técnica:</h6>
                        <template v-if="dados.nmUnidadeTecnica == null || dados.nmUnidadeTecnica == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.nmUnidadeTecnica"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Representante Legal:</h6>
                        <template v-if="dados.nmAdvogado == null || dados.nmAdvogado == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.nmAdvogado"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Assunto:</h6>
                        <template v-if="dados.dsAssunto == null || dados.dsAssunto == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dsAssunto"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Sumário:</h6>
                        <template v-if="dados.dsSumario == null || dados.dsSumario == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dsSumario"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Acórdão:</h6>
                        <template v-if="dados.dsAcordao == null || dados.dsAcordao == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dsAcordao"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Quórum:</h6>
                        <template v-if="dados.dsQuorum == null || dados.dsQuorum == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dsQuorum"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Relatório:</h6>
                        <template v-if="dados.nmRelatorio == null || dados.nmRelatorio == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.nmRelatorio"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Voto:</h6>
                        <template v-if="dados.dsVoto == null || dados.dsVoto == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dsVoto"></span>
                        </template>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-md-12">
                        <h6 >Fragmentos do Inteiro Teor:</h6>
                        <template v-if="dados.dsFragmentosInteiroTeor == null || dados.dsFragmentosInteiroTeor == ''">
                            <span >...</span>
                        </template>
                        <template v-else>
                            <span  v-html="dados.dsFragmentosInteiroTeor"></span>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer pb-0 mt-4 d-flex justify-content-end">
            <button class="btn-default bg-solid-primary txt-size-14" @click="imprimir">
                <i class="fas fa-print"></i> Imprimir
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'viewACORD',
        components: { },
        data: function () {
            return {
                tpConteudo: 'Pesquisa',
                cdConteudo: 'ACORD',
            }
        },
        props: {
            dados: Object,
            busca: Object,
        },
        methods: {
            
            imprimir() {
                var conteudo = document.getElementById('divImprimir').innerHTML,
                    tela_impressao = window.open('about:blank');

                tela_impressao.document.write(conteudo);
                tela_impressao.window.print();
                tela_impressao.window.close();
            },
        },
        mounted: function () {
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

   
</style>

